import { Link, useLocation, useParams } from 'react-router-dom';
import { Loading } from '../../components/Loading';
import ErrorMessageBox from '../../components/ErrorMessageBox';
import { UserBookInfo } from '../common/UserBookInfo';
import { createFetchErrorMessage } from 'utils/api/ApiClient';
import { getEpisode } from '../apiUserBook';
import { useQuery } from "@tanstack/react-query";
import { UserBookEpisodeForm } from './UserBookEpisodeForm';


export const UserBookEpisodeEdit = () => {
    const location = useLocation();
    const { school, book, episode } = useParams();

    const { data: userBookEpisode, isLoading, isError, error } = useQuery({
        queryKey: ['userbook/episode', episode],
        queryFn: getEpisode,
        refetchOnMount: 'always',
        refetchOnWindowFocus: false,
        gcTime: Infinity,
        staleTime: Infinity
    });

    if (isLoading) return <Loading />
    if (isError) return <ErrorMessageBox message={createFetchErrorMessage(error).message}
        goto={<Link className="btn _border" to={`/${school}/userbook${location.search}`} >목록</Link>} />;

    const initialData = { subject: userBookEpisode.data?.episode.subject, content: userBookEpisode.data?.episode.content, id: episode };

    return (
        <div className="userBookEpisodeForm">
            <UserBookInfo bookId={book} />
            <UserBookEpisodeForm initialData={initialData} />
        </div>
    );
};